import { Check } from "lucide-react";

/**
 * Compact 4-point trust reassurance strip shown beneath every major CTA.
 *
 *   ✓ No obligation
 *   ✓ No sales pressure
 *   ✓ Response within one working day
 *   ✓ UK-based intellectual property specialists
 *
 * Props:
 *   align      - "center" (default) | "left"
 *   theme      - "light" (default, navy text on white) | "dark" (light text on navy)
 *   className  - extra Tailwind classes if needed
 */
const ITEMS = [
  "No obligation",
  "No sales pressure",
  "Response within one working day",
  "UK-based intellectual property specialists",
];

export default function TrustStatement({ align = "center", theme = "light", className = "" }) {
  const isDark = theme === "dark";
  const wrapJustify = align === "left" ? "justify-start" : "justify-center";
  const textColor = isDark ? "text-[#9ac7f7]" : "text-[#447694]";
  const tickBg = isDark ? "bg-[#71edc9]/20 text-[#71edc9]" : "bg-[#71edc9]/35 text-[#04273d]";
  return (
    <ul
      className={`mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 ${wrapJustify} ${className}`}
      data-testid="trust-statement"
    >
      {ITEMS.map((label) => (
        <li
          key={label}
          className={`inline-flex items-center gap-1.5 text-[12px] md:text-[12.5px] font-medium ${textColor}`}
        >
          <span className={`inline-flex h-4 w-4 rounded-full items-center justify-center ${tickBg}`}>
            <Check size={11} strokeWidth={3} />
          </span>
          <span>{label}</span>
        </li>
      ))}
    </ul>
  );
}
